import { render } from "./WorkspaceFederationDefinitionAssociationsList.vue?vue&type=template&id=664b0564&scoped=true&ts=true"
import script from "./WorkspaceFederationDefinitionAssociationsList.vue?vue&type=script&lang=ts"
export * from "./WorkspaceFederationDefinitionAssociationsList.vue?vue&type=script&lang=ts"

import "./WorkspaceFederationDefinitionAssociationsList.vue?vue&type=style&index=0&id=664b0564&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664b0564"]])

export default __exports__